import { render, staticRenderFns } from "./SimulacaoEditCredito.vue?vue&type=template&id=0648f1e3"
import script from "./SimulacaoEditCredito.vue?vue&type=script&lang=js"
export * from "./SimulacaoEditCredito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports